import React from 'react'
import { NumericFormat } from 'react-number-format'

import { cn, inputVariants } from '@rewardops/ui'

import { useFormat } from '../hooks/use-format'

export const NumberInput = ({
  id,
  name,
  error,
  value,
  OnChange,
  className,
  placeholder = '',
}: {
  id: string
  name: string
  error: any
  value: number
  OnChange: (value: ((prevState: number) => number) | number) => void
  className?: string
  placeholder?: string
}) => {
  const { formatNumber } = useFormat()

  return (
    <div id={id} className={cn('flex-col', className)}>
      <div
        className={cn({
          'text-red-500': error,
        })}
      >
        {name}
      </div>
      <NumericFormat
        id={`${id}-input`}
        className={cn(
          inputVariants(),
          'rounded border',
          {
            'border-red-500': error,
          },
          className,
        )}
        placeholder={placeholder}
        value={value === 0 ? '' : formatNumber(value)}
        decimalScale={0}
        allowNegative={false}
        thousandSeparator=","
        onValueChange={({ value: stringValue }, { source }) => {
          const newValue = Number(stringValue)

          if (source === 'event') {
            OnChange(newValue)
          }
        }}
      />
    </div>
  )
}
